import { ValidationLevel, ValidationProps } from 'ui';
import { ExperienceTransferItem, ExperienceTransferItemValidation } from '../types-store';
import { ExperienceTransferTranslation } from 'app/area/experience-transfer/constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { formFields } from 'app/area/experience-transfer/form/constants';

const itemsWithValue = (object) => {
  return Object.keys(object).reduce((acc, key) => {
    if (object[key] !== undefined) {
      acc[key] = object[key];
    }
    return acc;
  }, {});
};

export const validateExperienceTransfer = (
  experienceTransferItem: ExperienceTransferItem,
  translation: ExperienceTransferTranslation
): ExperienceTransferItemValidation => {

  const subscriberGroupValidation = validatePicker(formFields.subscriberGroup, experienceTransferItem, translation);
  const caseTypeValidation = validatePicker(formFields.caseType, experienceTransferItem, translation);
  const criteriaValidation = validatePicker(formFields.criteria, experienceTransferItem, translation);
  const operationValidation = validatePicker(formFields.operation, experienceTransferItem, translation);

  return itemsWithValue({
    ...subscriberGroupValidation,
    ...caseTypeValidation,
    ...criteriaValidation,
    ...operationValidation
  });
};

const validatePicker = (
  id: string,
  item: ExperienceTransferItem,
  translation: ExperienceTransferTranslation
): { [key: string]: ValidationProps } => {
  return {
    [id]: isDefinedIncludingZero(item[id]?.value) ? undefined : {
      level: ValidationLevel.error,
      messages: [{
        level: ValidationLevel.error,
        message: translation.must_be_filled_out
      }]
    }
  };
};
